import React, { useEffect, useState } from 'react';
import {
  Container,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  Paper,
  TextField,
} from '@mui/material';
import axios from 'axios';
import SuperAdminLayout from '../../../layouts/SuperAdminLayout';
import api from '../../../utils/api';

const PriceList = () => {
  const user = JSON.parse(localStorage.getItem('user'));
  const superAdminId = user?.id;
  const [priceList, setPriceList] = useState([]);

  useEffect(() => {
    const fetchPriceList = async () => {
      try {
        const res = await api.get(`/api/reports/price-list/${superAdminId}`);
        const data = res.data.map((item) => {
          const avg = parseFloat(item.avgPurchaseRate || 0);
          const min = parseFloat(item.minSalePrice || 0);
          const profitPercent =
            avg > 0 && min > 0 ? ((min - avg) / avg) * 100 : 0;

          return {
            ...item,
            profitPercent: profitPercent.toFixed(2), // ✅ add this field
          };
        });
        setPriceList(data);
      } catch (err) {
        console.error('Failed to fetch price list:', err);
      }
    };

    fetchPriceList();
  }, [superAdminId]);

  const handleMinPriceChange = async (product, newPrice) => {
    const avgPurchaseRate = parseFloat(product.avgPurchaseRate || 0);
    const minSalePrice = parseFloat(newPrice);

    const profitPercent =
      avgPurchaseRate > 0
        ? ((minSalePrice - avgPurchaseRate) / avgPurchaseRate) * 100
        : 0;

    try {
      await api.put(`/api/products/update-min-price/${product._id}`, {
        minSalePrice,
        profitPercent,
        superAdminId,
      });

      setPriceList((prev) =>
        prev.map((p) =>
          p._id === product._id
            ? {
                ...p,
                minSalePrice,
                profitPercent: profitPercent.toFixed(2),
              }
            : p
        )
      );
    } catch (err) {
      console.error('❌ Failed to update min sale price:', err);
    }
  };

  return (
    <SuperAdminLayout>
      <Container maxWidth="screen">
        <Typography variant="h5" align="left" gutterBottom mt={3}>
          Price List Report
        </Typography>

        <TableContainer component={Paper} sx={{ mt: 3 }}>
          <Table size="small">
            <TableHead sx={{ backgroundColor: '#f5f5f5' }}>
              <TableRow>
                <TableCell sx={{ fontSize: 13, padding: '6px' }}>
                  <strong>Product Name</strong>
                </TableCell>
                <TableCell align="center" sx={{ fontSize: 13, padding: '6px' }}>
                  <strong>Avg Purchase Rate</strong>
                </TableCell>
                <TableCell align="center" sx={{ fontSize: 13, padding: '6px' }}>
                  <strong>Min Sale Price</strong>
                </TableCell>
                <TableCell align="center" sx={{ fontSize: 13, padding: '6px' }}>
                  <strong>Profit %</strong>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {priceList.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={4} align="center">
                    No products found
                  </TableCell>
                </TableRow>
              ) : (
                priceList.map((item) => (
                  <TableRow key={item._id}>
                    <TableCell sx={{ fontSize: 13, padding: '6px' }}>
                      {item.productName}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{ fontSize: 13, padding: '6px' }}
                    >
                      ₹{item.avgPurchaseRate}
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{ fontSize: 13, padding: '6px' }}
                    >
                      <TextField
                        size="small"
                        type="number"
                        value={item.minSalePrice}
                        onChange={(e) =>
                          handleMinPriceChange(item, e.target.value)
                        }
                        sx={{ width: '90px' }}
                      />
                    </TableCell>
                    <TableCell
                      align="center"
                      sx={{ fontSize: 13, padding: '6px' }}
                    >
                      {item.profitPercent ? `${item.profitPercent}%` : '0.00%'}
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Container>
    </SuperAdminLayout>
  );
};

export default PriceList;
